module.exports = __webpack_public_path__ + "static/media/Cheer Boi.8de3a694.svg";